import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import CreatableSelect from "react-select/creatable";
import { contactData } from "../../../data/json/contactData";
import DatePicker from "react-datepicker";
import { SelectWithImage } from "../../selectWithImage";
import Select from "react-select";
import { all_tags } from "../../selectoption/selectoption";
import { addEditContactOrLead } from "../../../api/contactApi";
import { useDispatch } from "react-redux";
import { showToast } from "../../../data/redux/slices/ToastSlice";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";

const activities = [
  { value: "choose", label: "Choose" },
  { value: "phoneCalls", label: "Phone Calls" },
  { value: "socialMedia", label: "Social Media" },
  { value: "referralSites", label: "Referral Sites" },
  { value: "webAnalytics", label: "Web Analytics" },
  { value: "previousPurchases", label: "Previous Purchases" },
];
const industries = [
  { value: "choose", label: "Choose" },
  { value: "Retail Industry", label: "Retail Industry" },
  { value: "Banking", label: "Banking" },
  { value: "Hotels", label: "Hotels" },
  { value: "Financial Services", label: "Financial Services" },
  { value: "Insurance", label: "Insurance" },
];
const countries = [
  { value: "Choose", label: "Choose" },
  { value: "India", label: "India" },
  { value: "USA", label: "USA" },
  { value: "France", label: "France" },
  { value: "UAE", label: "UAE" },
];

const CustomerOffcanvas = ({
  selectedCustomer,
  onContactUpdated,
  isLead = false,
}) => {
  const dispatch = useDispatch();
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [openModal2, setOpenModal2] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  // Form state
  const [formData, setFormData] = useState({
    firstname: "",
    lastname: "",
    company: "",
    designation: "",
    emailAddresses: [""],
    phoneNumbers: [""],
    linkedin: "",
    instagram: "",
    telegram: "",
    twitter: "",
    facebook: "",
    notes: "",
    website: "",
    isFavourite: false,
    isLead,
    tags: [],
  });
  const [contactImage, setContactImage] = useState(null);
  const [imagePreview, setImagePreview] = useState(null);

  // Populate form when editing
  useEffect(() => {
    if (selectedCustomer && selectedCustomer._originalData) {
      const data = selectedCustomer._originalData;

      // Convert phone numbers from backend format to PhoneInput format
      let phoneNumbers = [""];
      if (data.phoneNumbers && data.phoneNumbers.length > 0) {
        phoneNumbers = data.phoneNumbers.map((phone) => {
          if (typeof phone === "string") return phone;
          // Convert { countryCode: "971", number: "123456789" } to "971123456789"
          return `${phone.countryCode || ""}${phone.number || ""}`;
        });
      }

      setFormData({
        firstname: data.firstname || "",
        lastname: data.lastname || "",
        company: data.company || "",
        designation: data.designation || "",
        emailAddresses:
          data.emailAddresses && data.emailAddresses.length > 0
            ? data.emailAddresses
            : [""],
        phoneNumbers: phoneNumbers,
        linkedin: data.linkedin || "",
        instagram: data.instagram || "",
        telegram: data.telegram || "",
        twitter: data.twitter || "",
        facebook: data.facebook || "",
        notes: data.notes || "",
        website: data.website || "",
        isFavourite: data.isFavourite || false,
        isLead: data.isLead || false,
        tags: data.tags || [],
      });

      if (data.contactImageURL) {
        setImagePreview(data.contactImageURL);
      }
    } else {
      // Reset form for new contact
      setFormData({
        firstname: "",
        lastname: "",
        company: "",
        designation: "",
        emailAddresses: [""],
        phoneNumbers: [""],
        linkedin: "",
        instagram: "",
        telegram: "",
        twitter: "",
        facebook: "",
        notes: "",
        website: "",
        isFavourite: false,
        isLead,
        tags: [],
      });
      setContactImage(null);
      setImagePreview(null);
    }
  }, [selectedCustomer]);

  const handleInputChange = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
  };

  const handleEmailChange = (index, value) => {
    const newEmails = [...formData.emailAddresses];
    newEmails[index] = value;
    setFormData((prev) => ({ ...prev, emailAddresses: newEmails }));
  };

  const addEmailField = () => {
    setFormData((prev) => ({
      ...prev,
      emailAddresses: [...prev.emailAddresses, ""],
    }));
  };

  const removeEmailField = (index) => {
    const newEmails = formData.emailAddresses.filter((_, i) => i !== index);
    setFormData((prev) => ({ ...prev, emailAddresses: newEmails }));
  };

  const handlePhoneChange = (index, value, country) => {
    const newPhones = [...formData.phoneNumbers];
    newPhones[index] = value; // PhoneInput provides the full number as a string
    setFormData((prev) => ({ ...prev, phoneNumbers: newPhones }));
  };

  const addPhoneField = () => {
    setFormData((prev) => ({
      ...prev,
      phoneNumbers: [...prev.phoneNumbers, ""],
    }));
  };

  const removePhoneField = (index) => {
    const newPhones = formData.phoneNumbers.filter((_, i) => i !== index);
    setFormData((prev) => ({ ...prev, phoneNumbers: newPhones }));
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setContactImage(file);
      const reader = new FileReader();
      reader.onloadend = () => {
        setImagePreview(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);

    try {
      // Check if editing or creating
      const isEditing = selectedCustomer && selectedCustomer._originalData;

      // Frontend validation for BOTH creation and editing
      // Check firstname
      if (!formData.firstname || formData.firstname.trim() === "") {
        dispatch(
          showToast({
            message: "First name is required",
            type: "error",
          })
        );
        setSubmitting(false);
        return;
      }

      // Check at least one email
      // const validEmails = formData.emailAddresses.filter(
      //   (email) => email && email.trim() !== ""
      // );
      // if (validEmails.length === 0) {
      //   dispatch(
      //     showToast({
      //       message: "At least one email address is required",
      //       type: "error",
      //     })
      //   );
      //   setSubmitting(false);
      //   return;
      // }

      // Check at least one phone number
      const validPhones = formData.phoneNumbers.filter(
        (phone) => phone && phone.trim() !== ""
      );
      if (validPhones.length === 0) {
        dispatch(
          showToast({
            message: "At least one phone number is required",
            type: "error",
          })
        );
        setSubmitting(false);
        return;
      }

      const formDataToSend = new FormData();

      // Add contact_id if editing
      if (isEditing) {
        formDataToSend.append(
          "contact_id",
          selectedCustomer._originalData.contact_id ||
            selectedCustomer._originalData._id
        );
      }

      // Add basic fields
      formDataToSend.append("firstname", formData.firstname);
      formDataToSend.append("lastname", formData.lastname);
      formDataToSend.append("company", formData.company);
      formDataToSend.append("designation", formData.designation);
      formDataToSend.append("linkedin", formData.linkedin);
      formDataToSend.append("instagram", formData.instagram);
      formDataToSend.append("telegram", formData.telegram);
      formDataToSend.append("twitter", formData.twitter);
      formDataToSend.append("facebook", formData.facebook);
      formDataToSend.append("notes", formData.notes);
      formDataToSend.append("website", formData.website);
      formDataToSend.append("isFavourite", formData.isFavourite);
      formDataToSend.append("isLead", formData.isLead);

      // Add arrays as JSON strings
      const cleanedEmails = formData.emailAddresses.filter(
        (email) => email.trim() !== ""
      );
      formDataToSend.append("emailAddresses", JSON.stringify(cleanedEmails));

      // Convert PhoneInput format back to backend format
      const cleanedPhones = formData.phoneNumbers
        .filter((phone) => phone && phone.trim() !== "")
        .map((phone) => {
          // PhoneInput returns format like "971501234567"
          // We need to extract country code and number
          // For simplicity, we'll use a library function or manual parsing
          // Assuming first 1-3 digits are country code
          let countryCode = "";
          let number = "";

          if (phone.length > 0) {
            // Try common country code lengths (1-3 digits)
            if (phone.startsWith("971")) {
              countryCode = phone.substring(0, 3);
              number = phone.substring(3);
            } else if (phone.startsWith("1") && phone.length === 11) {
              countryCode = phone.substring(0, 1);
              number = phone.substring(1);
            } else if (phone.length > 3) {
              // Default: assume 2-digit country code
              countryCode = phone.substring(0, 2);
              number = phone.substring(2);
            } else {
              number = phone;
            }
          }

          return { countryCode, number };
        });
      formDataToSend.append("phoneNumbers", JSON.stringify(cleanedPhones));

      // Add image if selected
      if (contactImage) {
        formDataToSend.append("contactImage", contactImage);
      }

      formDataToSend.append("category", isLead ? "lead" : "contact");

      const response = await addEditContactOrLead(formDataToSend);

      if (response.status === "success") {
        dispatch(
          showToast({
            message: response.message,
            type: "success",
          })
        );

        // Close offcanvas using data-bs-dismiss trigger
        const closeButton = document.querySelector(
          '#customer_offcanvas [data-bs-dismiss="offcanvas"]'
        );
        if (closeButton) {
          closeButton.click();
        }

        // Refresh contact list - pass contact_id and updated data
        if (onContactUpdated) {
          const contact_id = isEditing
            ? selectedCustomer._originalData.contact_id ||
              selectedCustomer._originalData._id
            : response.data.contact_id || response.data._id;
          isEditing
            ? onContactUpdated(contact_id, response.data)
            : onContactUpdated();
        }

        // Reset form
        setFormData({
          firstname: "",
          lastname: "",
          company: "",
          designation: "",
          emailAddresses: [""],
          phoneNumbers: [""],
          linkedin: "",
          instagram: "",
          telegram: "",
          twitter: "",
          facebook: "",
          notes: "",
          website: "",
          isFavourite: false,
          isLead: false,
          tags: [],
        });
        setContactImage(null);
        setImagePreview(null);
      }
    } catch (error) {
      console.error("Error saving contact:", error);
      dispatch(
        showToast({
          message: error.response?.data?.message || "Failed to save contact",
          type: "error",
        })
      );
    } finally {
      setSubmitting(false);
    }
  };

  const all_companies = [
    ...new Set(
      contactData
        .map((contact) => contact.customer_company)
        .filter((company) => company !== "") // Filter out empty companies
    ),
  ].map((company) => ({ label: company, value: company }));
  const handleDateChange = (date) => {
    setSelectedDate(date);
  };
  return (
    <>
      <div
        className={`offcanvas offcanvas-end offcanvas-large`}
        tabIndex={-1}
        id="customer_offcanvas"
        aria-modal="true"
        role="dialog"
      >
        <div className="offcanvas-header border-bottom">
          <h5 className="fw-semibold">
            {selectedCustomer ? "Edit Customer" : "Add new Customer"}
          </h5>
          <button
            type="button"
            className="btn-close custom-btn-close border p-1 me-0 d-flex align-items-center justify-content-center rounded-circle"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
          >
            <i className="ti ti-x" />
          </button>
        </div>
        <div className="offcanvas-body">
          <form>
            <div className="accordion" id="main_accordion">
              {/* Basic Info */}

              <div
                className="accordion-collapse collapse show"
                id="basic"
                data-bs-parent="#main_accordion"
              >
                <div className="accordion-body ">
                  <div className="row">
                    <div className="col-md-6">
                      <div className="mb-3">
                        <label className="col-form-label">
                          First Name <span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          value={formData.firstname}
                          onChange={(e) =>
                            handleInputChange("firstname", e.target.value)
                          }
                          className="form-control"
                          required
                        />
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="mb-3">
                        <label className="col-form-label">Last Name</label>
                        <input
                          type="text"
                          value={formData.lastname}
                          onChange={(e) =>
                            handleInputChange("lastname", e.target.value)
                          }
                          className="form-control"
                        />
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="mb-3">
                        <label className="col-form-label">Job Title</label>
                        <input
                          type="text"
                          value={formData.designation}
                          onChange={(e) =>
                            handleInputChange("designation", e.target.value)
                          }
                          className="form-control"
                        />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="mb-3">
                        <label className="col-form-label">Company Name</label>
                        <input
                          type="text"
                          value={formData.company}
                          onChange={(e) =>
                            handleInputChange("company", e.target.value)
                          }
                          className="form-control"
                        />
                      </div>
                    </div>
                    <div className="col-md-12">
                      <div className="mb-3">
                        <label className="col-form-label">
                          Email Addresses <span className="text-danger">*</span>
                        </label>
                        {formData.emailAddresses.map((email, index) => (
                          <div key={index} className="d-flex mb-2">
                            <input
                              type="email"
                              className="form-control me-2"
                              value={email}
                              onChange={(e) =>
                                handleEmailChange(index, e.target.value)
                              }
                              placeholder="email@example.com"
                            />
                            {formData.emailAddresses.length > 1 && (
                              <button
                                type="button"
                                className="btn btn-danger btn-sm"
                                onClick={() => removeEmailField(index)}
                              >
                                <i className="ti ti-trash" />
                              </button>
                            )}
                          </div>
                        ))}
                        <button
                          type="button"
                          className="btn btn-sm btn-primary"
                          onClick={addEmailField}
                        >
                          <i className="ti ti-plus me-1" /> Add Email
                        </button>
                      </div>
                    </div>
                    <div className="col-md-12">
                      <div className="mb-3">
                        <label className="col-form-label">
                          Phone Numbers <span className="text-danger">*</span>
                        </label>
                        {formData.phoneNumbers.map((phone, index) => (
                          <div
                            key={index}
                            className="d-flex mb-2 align-items-center"
                          >
                            <div style={{ flex: 1 }}>
                              <PhoneInput
                                country={"ae"}
                                value={phone}
                                onChange={(value, country) =>
                                  handlePhoneChange(index, value, country)
                                }
                                enableSearch
                                inputProps={{
                                  name: `phone-${index}`,
                                  required: index === 0,
                                  autoFocus: false,
                                }}
                                inputStyle={{
                                  width: "100%",
                                }}
                                // buttonStyle={{
                                //   border: "1px solid #e9ecef",
                                //   borderRight: "none",
                                //   height: "30px",
                                //   backgroundColor: "transparent",
                                // }}
                                containerStyle={{ width: "100%" }}
                              />
                            </div>
                            {formData.phoneNumbers.length > 1 && (
                              <button
                                type="button"
                                className="btn btn-danger btn-sm ms-2"
                                onClick={() => removePhoneField(index)}
                              >
                                <i className="ti ti-trash" />
                              </button>
                            )}
                          </div>
                        ))}
                        <button
                          type="button"
                          className="btn btn-sm btn-primary"
                          onClick={addPhoneField}
                        >
                          <i className="ti ti-plus me-1" /> Add Phone
                        </button>
                      </div>
                    </div>

                    {/* <div className="col-md-6">
                      <div className="mb-3">
                        <label className="col-form-label">Profile Image</label>
                        <input
                          type="file"
                          className="form-control"
                          accept="image/*"
                          onChange={handleImageChange}
                        />
                        {imagePreview && (
                          <div className="mt-2">
                            <img
                              src={imagePreview}
                              alt="Preview"
                              style={{
                                width: "100px",
                                height: "100px",
                                objectFit: "cover",
                                borderRadius: "8px",
                              }}
                            />
                          </div>
                        )}
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="mb-3">
                        <label className="col-form-label">Website</label>
                        <input
                          type="url"
                          className="form-control"
                          value={formData.website}
                          onChange={(e) =>
                            handleInputChange("website", e.target.value)
                          }
                          placeholder="https://example.com"
                        />
                      </div>
                    </div>

                    <div className="col-md-12">
                      <div className="mb-3">
                        <label className="col-form-label">Notes</label>
                        <textarea
                          className="form-control"
                          rows={3}
                          value={formData.notes}
                          onChange={(e) =>
                            handleInputChange("notes", e.target.value)
                          }
                        />
                      </div>
                    </div> */}

                    <div className="col-md-6">
                      <div className="mb-0">
                        <div className="form-check">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            id="isFavourite"
                            checked={formData.isFavourite}
                            onChange={(e) =>
                              handleInputChange("isFavourite", e.target.checked)
                            }
                          />
                          <label
                            className="form-check-label"
                            htmlFor="isFavourite"
                          >
                            Mark as Favourite
                          </label>
                        </div>
                      </div>
                    </div>

                    <div
                      className="col-md-6 "
                      style={{ height: "0px", overflow: "hidden" }}
                    >
                      <div className="mb-0">
                        <div className="form-check">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            id="isLead"
                            checked={formData.isLead}
                            onChange={(e) => console.log("cant change")}
                          />
                          <label className="form-check-label" htmlFor="isLead">
                            Mark as Lead
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* /Basic Info */}

              {/* Social Profile */}
              {/* <div className="accordion-item border-top rounded mb-3">
                <div className="accordion-header">
                  <Link
                    to=""
                    className="accordion-button accordion-custom-button rounded bg-white fw-medium text-dark collapsed"
                    data-bs-toggle="collapse"
                    data-bs-target="#social"
                  >
                    <span className="avatar avatar-md rounded text-dark border me-2">
                      <i className="ti ti-social fs-20" />
                    </span>
                    Social Media Links
                  </Link>
                </div>
                <div
                  className="accordion-collapse collapse"
                  id="social"
                  data-bs-parent="#main_accordion"
                >
                  <div className="accordion-body border-top">
                    <div className="row">
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="col-form-label">LinkedIn</label>
                          <input
                            type="url"
                            className="form-control"
                            value={formData.linkedin}
                            onChange={(e) =>
                              handleInputChange("linkedin", e.target.value)
                            }
                            placeholder="https://linkedin.com/in/username"
                          />
                        </div>
                      </div>

                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="col-form-label">Instagram</label>
                          <input
                            type="text"
                            className="form-control"
                            value={formData.instagram}
                            onChange={(e) =>
                              handleInputChange("instagram", e.target.value)
                            }
                            placeholder="@username or URL"
                          />
                        </div>
                      </div>

                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="col-form-label">Twitter</label>
                          <input
                            type="text"
                            className="form-control"
                            value={formData.twitter}
                            onChange={(e) =>
                              handleInputChange("twitter", e.target.value)
                            }
                            placeholder="@username or URL"
                          />
                        </div>
                      </div>

                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="col-form-label">Facebook</label>
                          <input
                            type="text"
                            className="form-control"
                            value={formData.facebook}
                            onChange={(e) =>
                              handleInputChange("facebook", e.target.value)
                            }
                            placeholder="Profile URL"
                          />
                        </div>
                      </div>

                      <div className="col-md-6">
                        <div className="mb-3 mb-md-0">
                          <label className="col-form-label">Telegram</label>
                          <input
                            type="text"
                            className="form-control"
                            value={formData.telegram}
                            onChange={(e) =>
                              handleInputChange("telegram", e.target.value)
                            }
                            placeholder="@username"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div> */}
              {/* /Social Profile */}
            </div>
            <div className="d-flex align-items-center justify-content-end">
              <button
                type="button"
                data-bs-dismiss="offcanvas"
                className="btn btn-light me-2"
              >
                Cancel
              </button>
              <button
                type="submit"
                className="btn btn-primary"
                onClick={handleSubmit}
                disabled={submitting}
              >
                {submitting ? (
                  <>
                    <span
                      className="spinner-border spinner-border-sm me-2"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    Saving...
                  </>
                ) : selectedCustomer ? (
                  "Save Changes"
                ) : isLead ? (
                  "Create Lead"
                ) : (
                  "Create Contact"
                )}
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default CustomerOffcanvas;
